import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {GlobalQuestionService} from '../../../services/global-question.service';
import {Question, VapQuestion} from '../../../models/underwriter.model';

@Component({
    selector: 'app-vaps-general-eight',
    templateUrl: './vaps-general-eight.component.html',
    styleUrls: ['./vaps-general-eight.component.scss'],
    standalone: false
})
export class VapsGeneralEightComponent implements OnInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: VapQuestion;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<number>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();

  selectedOption: any;
  productDetailsId: any;

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answers) {
        this.question.answers_parsed = JSON.parse(this.question?.answers);
      }
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(0);
      this.selectedOption = '';
      this.getProductDetails();
    }
  }

  getProductDetails(): any {
    if (this.question?.answers_parsed?.length) {
      const item = this.question?.answers_parsed[0]?.answer?.split('|');
      if (item?.length) {
        this.productDetailsId = item[1];
      }
    }
  }

  calculate(): void {
    this.onChange(1);
  }

  selectChange(value: Question): void {
    this.selectedOption = value?.answer;
    this.onChange(0);
  }

  onChange(action: number): void {
    if (this.selectedOption) {
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.selectedOption.toString();
      this.question.answer = answer;
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, '1', answer, 0, '')
        .subscribe(() => {
          if (action === 1) {
            this.globalQuestionService.resetVaps(true);
            this.globalQuestionService.spinner(false);
          } else {
            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, '1', this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  let amount = 0;
                  p?.forEach(item => {
                    amount += +item?.premium;
                  });
                  this.amountChanged.emit(amount);
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });
          }
        });
    } else {
      this.amountChanged.emit(0);
    }
  }
}
